import { render, staticRenderFns } from "./FireReports.vue?vue&type=template&id=e2bea7d4&"
import script from "./FireReports.vue?vue&type=script&lang=js&"
export * from "./FireReports.vue?vue&type=script&lang=js&"
import style0 from "./FireReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireReports.vue"
export default component.exports